export default "__VITE_ASSET__NiRtI8Uv__"